

















import Vue from 'vue';
import SessionCard from '@/components/Presenter/SessionCard.vue';
export default Vue.extend({
  name: 'SessionSection',
  components: { SessionCard },
  props: {
    sessions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isPausePlayVisible: true,
    };
  },
  methods: {
    goToSessionDetail(session: any): void {
      this.$router.push({
        name: 'Presenter Session Stats',
        params: { presenterSessionId: session.shareToken, session },
      });
    },
  },
});
